import { Translate } from "../components/i18n/i18n";

export const ConvertToString = (dt, format = 'db') => {
    const year = dt.getUTCFullYear();
    const month = ('0' + (dt.getUTCMonth() + 1)).substr(-2);
    const day = ('0' + dt.getUTCDate()).substr(-2);
    return format === 'db' ? `${year}-${month}-${day}` : `${day}/${month}/${year}`;
}

export const ConvertToDate = (str, format = 'db') => {
    let parts = format === 'db' ? /(\d{4})-(\d{2})-(\d{2})/gi.exec(str) : /(\d{2})\/(\d{2})\/(\d{4})/gi.exec(str);;
    if (!parts) {        
        return null;
    }
    const year = parseInt(parts[format === 'db' ? 1 : 3]);
    const month = parseInt(parts[2]) - 1;
    const day = parseInt(parts[format === 'db' ? 3 : 1]);

    const dt = new Date();
    dt.setDate(day);
    dt.setMonth(month);
    dt.setFullYear(year);

    return dt;

}

export const FormatDate = (str) => {
    if (!str) {
        return Translate('tables.dateUndefined');
    }

    let dt = ConvertToDate(str);

    if (!dt) {
        return Translate('tables.dateUndefined');    
    }

    let ddd = Translate('date-ddd.'+dt.getUTCDay());
    let mm = Translate('date-mm.'+dt.getUTCMonth());

    let dateLongFormat = Translate('datelong');
    dateLongFormat = dateLongFormat.replace("$1", ddd);
    dateLongFormat = dateLongFormat.replace("$2", dt.getUTCDate());
    dateLongFormat = dateLongFormat.replace("$3", mm);
    dateLongFormat = dateLongFormat.replace("$4", dt.getUTCFullYear());
    return dateLongFormat;
}

export const ConvertToTime = (time, locale) => {
    let hour = time.substring(0, 2);
    let minute = time.substring(3, 5);

    if (locale === 'en') {
        let hourInt = parseInt(hour);
        let AMorPM = 'AM';

        if(hourInt > 12) {
            hourInt -= 12;
            AMorPM = 'PM';
        }

        if(hourInt < 10) {
            hourInt = '0'+hourInt;
        }

        return `${hourInt}:${minute} ${AMorPM}`;
    } else if (locale === 'pt') {
        return `${hour}h${(minute !== '00' ? minute : '')}`
    }
}

export const YearDiff = (date1, date2 = new Date()) => {
    let time1 = date1.getTime();
    let time2 = date2.getTime();

    let a = Math.floor((time2 - time1) / (1000*60*60*24*365));
    
    if (a < 0) {
        return '-';
    }
    return a;
}

export const ConvertToTimeClock = (timestamp) => {
    let t = new Date();
    t.setTime(timestamp);

    let h = '00' + t.getHours();
    let m = '00' + t.getMinutes();

    return h.substring(h.length-2, h.length) + ':' + m.substring(m.length-2, m.length);

}

export const ConvertToTimeDisplay = (integerValue) => {
        let val = "0000"+String(integerValue);

        let hour = '00' + val.substring(val.length-4, val.length-2);
        let minute = '00' + val.substring(val.length-2, val.length);

        hour = hour.substring(hour.length - 2, hour.length);
        minute = minute.substring(minute.length - 2, minute.length);

        if (parseInt(hour) > 23) {
            hour = '00';
        }
        if (parseInt(minute) > 59) {
            minute = '00';
        }

        return hour + ":" + minute;
    }